import { createRouter, RouterProvider } from '@tanstack/react-router';
import type { FC } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { routeTree } from '@/routeTree.gen';

import { queryClient } from './queryClient';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    queryClient,
  },
});

export const Router: FC = () => {
  const qc = useQueryClient();
  return <RouterProvider router={router} context={{ queryClient: qc }} />;
};
